import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, toRef, watchEffect } from 'vue'
import { useFieldView } from '@/components/field-view-next/FieldViewState'


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewJobPanelProvision',
  props: {
    jobNumber: null
  },
  setup(__props: any) {

const props = __props as {
  jobNumber: string | number
}



const jobNumberRef = toRef(props, 'jobNumber')

const { setSelectedJobNumber, setSelectedLocation, setSelectedResource } =
  useFieldView()

onMounted(() => setSelectedJobNumber(props.jobNumber))

watchEffect(() => setSelectedJobNumber(jobNumberRef.value))

onUnmounted(() => {
  setSelectedJobNumber(null)
  setSelectedLocation(null)
  setSelectedResource(null)
})

return { __sfc: true,props, jobNumberRef, setSelectedJobNumber, setSelectedLocation, setSelectedResource }
}

})